import { FeaturedBuildings } from './FeaturedBuildings';

export function MapSection() {
  return (
    <main className="pt-40 pb-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <section className="text-center mb-12">
          <h1 className="font-['Fraunces'] text-4xl md:text-5xl font-bold text-[#505A5A] mb-4">
            Buildings That Allow <span className="text-[#882629]">STR&apos;s</span>
          </h1>
          <p className="text-base text-[#505A5A]/70 max-w-2xl mx-auto leading-relaxed">
            Explore our interactive map to see which buildings in Metro Vancouver currently permit short‑term rentals. This data is regularly updated based on strata bylaws and city regulations.
          </p>
        </section>

        <section className="w-full rounded-xl overflow-hidden shadow-lg border border-[#F0F0F0]">
          <iframe
            src="https://www.google.com/maps/d/u/0/embed?mid=1AgZdtvODDJM9bA1m1z4lJWABiXd_CIs&ehbc=882629&noprof=1&hl=en"
            width="100%"
            height="640"
            style={{ border: 0, minHeight: "480px" }}
            allowFullScreen
            loading="lazy"
            title="Buildings that allow short‑term rentals in Metro Vancouver"
            aria-label="Interactive Google Map showing buildings that allow short‑term rentals"
          />
        </section>

        <FeaturedBuildings />

        <section className="mt-16 grid md:grid-cols-3 gap-8">
          <div className="bg-[#F0F0F0] rounded-lg p-6">
            <div className="w-10 h-10 flex items-center justify-center text-[#882629] mb-3">
              <i className="ri-map-pin-line text-2xl"></i>
            </div>
            <h4 className="font-['Fraunces'] text-lg font-semibold text-[#505A5A] mb-2">
              <a href="#map-info" className="hover:text-[#882629] transition-colors">
                Verified Locations
              </a>
            </h4>
            <p className="text-sm text-[#505A5A]/70 leading-relaxed">
              Each pin represents a building where we have confirmed short‑term rental permissions through strata bylaw review.
            </p>
          </div>

          <div className="bg-[#F0F0F0] rounded-lg p-6">
            <div className="w-10 h-10 flex items-center justify-center text-[#882629] mb-3">
              <i className="ri-refresh-line text-2xl"></i>
            </div>
            <h4 className="font-['Fraunces'] text-lg font-semibold text-[#505A5A] mb-2">
              <a href="#map-info" className="hover:text-[#882629] transition-colors">
                Regularly Updated
              </a>
            </h4>
            <p className="text-sm text-[#505A5A]/70 leading-relaxed">
              Strata rules change frequently. We keep this map current so you always have the latest information.
            </p>
          </div>

          <div className="bg-[#F0F0F0] rounded-lg p-6">
            <div className="w-10 h-10 flex items-center justify-center text-[#882629] mb-3">
              <i className="ri-question-line text-2xl"></i>
            </div>
            <h4 className="font-['Fraunces'] text-lg font-semibold text-[#505A5A] mb-2">
              <a href="#map-info" className="hover:text-[#882629] transition-colors">
                Don&apos;t See Your Building?
              </a>
            </h4>
            <p className="text-sm text-[#505A5A]/70 leading-relaxed">
              If your building isn&apos;t listed, it doesn&apos;t necessarily mean STR&apos;s aren&apos;t allowed. Contact us for a personalized compliance check.
            </p>
          </div>
        </section>
      </div>
    </main>
  );
}
